import './SearchFilterStoreBar.scss';

import { func } from 'prop-types';
import React, { useState } from 'react';

import FilterStoreBtn from './filterStoreBtn';

const SearchFilterStoreBar = ({ onSearch, onFilter, onClearFilterArea }) => {
  const [keyword, setKeyWord] = useState('');

  const handleChangeSearchInput = (event) => {
    const value = event.target.value;

    setKeyWord(value);

    onSearch(value.toLowerCase());
  };

  const handleFilterArea = (values) => {
    onFilter(values.area.value);
  };

  return (
    <div className='store-locator__content__list__search search-filter-bar'>
      <div className='store-locator__search__input'>
        <input
          type='text'
          className='form-control form-control-lg store-locator__search__input__item'
          value={keyword}
          onChange={handleChangeSearchInput}
        />
      </div>

      <div className='store-locator__search__btn'>
        <FilterStoreBtn onFilterArea={handleFilterArea} onClearFilterArea={onClearFilterArea} />
      </div>
    </div>
  );
};

SearchFilterStoreBar.propTypes = {
  onSearch: func,
  onFilter: func,
  onClearFilterArea: func
};

export default SearchFilterStoreBar;
